import {Injectable} from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Route, Router } from '@angular/router';
import {Store} from '@ngxs/store';
import {AuthState} from '@shared/store/auth/auth.state';
import {EquipmentService} from '@shared/services/maintenance/equipment.service';
import {tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OpenInfoEquipmentGuard  {
  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private equipmentService: EquipmentService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    return this.checkLogin(route);
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    return this.checkLogin(route);
  }

  canLoad(route: Route): boolean {
    return this.checkLogin();
  }

  private checkLogin(route?: ActivatedRouteSnapshot): boolean {
    const equipmentId = route ? +route.paramMap.get('id') : null;

    if (this.store.selectSnapshot(AuthState.authenticated)) {
      if (equipmentId) {
        this.equipmentService.getById(equipmentId)
          .subscribe((details) => {
            let url = '/maintenance-equipment/' + details.categoryId;
            if (details.childCategoryId) {
              url += '/category/' + details.childCategoryId;
            }
            url += '/equipment/' + details.id;

            this.router.navigateByUrl(url);
          });
      }

      return false;
    }

    return true;
  }
}
